const state = {
   cargo:{},
}

export default state
